import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { Observable } from 'rxjs';
import { Globle } from 'src/assets/globle';
import { BillerList } from '../../billers-list/billerlist.model';
import { BillerlistService } from '../../billers-list/billerlist.service';
import { EFCategory } from '../../category/efCategory.model';
import { EfcategoryService } from '../../category/efcategory.service';
import { ServicetypeService } from '../servicetype.service';
import { map, startWith } from 'rxjs/operators';
import { ServiceType } from '../servicetype.model';

@Component({
  selector: 'app-servicetypelist',
  templateUrl: './servicetypelist.component.html',
  styleUrls: ['./servicetypelist.component.css']
})
export class ServicetypelistComponent implements OnInit {

  //#region variables
  Categories: EFCategory[] = [];
  billerList: BillerList[] = [];
  serviceTypeList: ServiceType[] = [];
  displayedColumns: string[] = ['id', 'arabicName', 'englishName', "edit"];
  dataSource!: MatTableDataSource<ServiceType>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('catgSearch') catgSearch: any
  @ViewChild('billersListSearch') billersListSearch: any
  spinnerOverlay = false

  serviceType: ServiceType = {} as ServiceType;
  subCatgstatus: { id: number, name: string }[] = [];
  selectedStatus: number = 1;
  selectedCategory: any
  selectedBiller: any
  filteredOptions!: Observable<EFCategory[]>;
  filteredOptionsBillersList!: Observable<BillerList[]>;
  searchCategory = new FormControl();
  searchBillersList = new FormControl();
  language!: number;
  imagPath: any;
  pageSize = 100;
  //#endregion

  constructor(
    private service: ServicetypeService,
    private billersListService: BillerlistService,
    private categoryService: EfcategoryService,
    private router: Router,
    private localStorage: LocalStorageService,
    private sessionStorage: SessionStorageService,
    private translate: TranslateService,
    private globle: Globle) { }

  ngOnInit() {
    this.subCatgstatus = [{ id: 1, name: "active" }, { id: 0, name: "notActive" }];
    this.selectedStatus = 1;
    this.language = this.localStorage.retrieve("lang");
    this.imagPath = this.globle.imgPath;
    this.pageSize = this.globle.pageSize;
    this.getCategory();
    this.searchCategory.markAsTouched();
    let category = this.sessionStorage.retrieve("categorySearch");
    let biller = this.sessionStorage.retrieve("billerSearch");
    if (category != null && category != undefined && biller != null && biller != undefined) {
      this.searchCategory.setValue(category);
      this.selectCatChange(category);
      this.billersListSearch.setValue(biller);
      this.selectBillerChange(biller);
    }
  }

  getCategory() {
    this.spinnerOverlay = true;
    this.categoryService.getAll(1).subscribe(data => {
      this.Categories = data
      this.autoCompleatFilter();
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  autoCompleatFilter() {
    this.filteredOptions = this.searchCategory.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.Categories.slice())
      );
  }

  private _filter(name: string): EFCategory[] {
    const filterValue = name.toLowerCase();

    return this.Categories.filter(option => option.aDesc.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFn(category: EFCategory): string {
    return category && category.aDesc ? category.aDesc : '';
  }

  getBillersList() {
    this.spinnerOverlay = true;
    this.billersListService.getAll(this.selectedCategory, this.selectedStatus).subscribe(data => {
      this.billerList = data
      this.autoCompleatFilterBillersList();
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  autoCompleatFilterBillersList() {
    this.filteredOptionsBillersList = this.searchBillersList.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.aDesc),
        map(name => name ? this._filterBillersList(name) : this.billerList.slice())
      );
  }

  private _filterBillersList(name: string): BillerList[] {
    const filterValue = name.toLowerCase();

    return this.billerList.filter(option => option.aDesc.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFnBillerList(billerList: BillerList): string {
    return billerList && billerList.aDesc ? billerList.aDesc : '';
  }

  getServices() {
    this.spinnerOverlay = true;
    this.service.getAll(this.selectedCategory, this.selectedStatus).subscribe(data => {
      this.serviceTypeList = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.serviceTypeList);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  edit(id: number) {
    this.router.navigate(['./master/efawateercome/efbillersservicetypeform/' + id]);
  }

  selectStatusChange() {
    this.getBillersList();
  }

  selectCatChange(value: any) {
    this.selectedCategory = value.id;
    this.sessionStorage.store("categorySearch", value);
    this.searchBillersList.reset();
    this.getBillersList();
  }

  selectBillerChange(value: any) {
    this.selectedCategory = value.id;
    this.sessionStorage.store("billerSearch", value);
    this.getServices();
  }

}
